import { useUser } from '@repo/domain-service';
import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';
import { UnderlineDecoration } from '@repo/ui';

import { selectStatus, useAuthStore } from '@features/auth';

import citySkyline from '@assets/images/city-skyline.webp';
import parkingSign from '@assets/images/parking-sign.webp';

interface Props {
  testId: TestId;
}

export default function Header({ testId }: Props) {
  const { user } = useUser();
  const isLoggedIn = useAuthStore(selectStatus) === 'authenticated';

  const punchline = isLoggedIn
    ? [tr('account:header.greeting'), user?.name ?? '']
    : [tr('account:header.guest_text'), tr('account:header.guest_highlighted')];

  const standardLines = punchline.slice(0, -1);
  const highlightedLine = punchline[punchline.length - 1];

  return (
    <div
      data-testid={testId}
      className="bg-brand-strong relative flex h-48 shrink-0 items-center justify-center overflow-hidden rounded-b-2xl text-white md:rounded-2xl"
    >
      <div className="flex flex-col items-center text-center">
        <h1 className="pb-6 font-semibold">{tr('bottom_bar.account')}</h1>
        <h2 className="max-w-80 text-2xl font-bold">
          {standardLines.map((line, index) => (
            <span key={index}>{line} </span>
          ))}
          <span className="relative inline-block" data-testid={testId.append('userName')}>
            {highlightedLine}
            <UnderlineDecoration />
          </span>
        </h2>
      </div>

      <img src={parkingSign} className="absolute -right-12.5 w-24" alt="" aria-hidden />
      <img src={parkingSign} className="absolute bottom-6 -left-10 w-28 rotate-24 blur-xs" alt="" aria-hidden />
      <img src={citySkyline} className="absolute bottom-0 h-20 w-full opacity-20" alt="" aria-hidden />
    </div>
  );
}
